export const translations = {
    GE: {
        slogan: 'ვაზიდან მეღვინეობამდე – ცოცხალი მემკვიდრეობა და უნიკალური ქართული ღვინო.',
        navTitle: 'ნავიგაცია',
        contactTitle: 'კონტაქტი',
        socialTitle: 'სოციალური ქსელები',
        home: 'მთავარი',
        about: 'ჩვენს შესახებ',
        products: 'პროდუქტები',
        contact: 'კონტაქტი',
        phone: '+995 592 292 828',
        email: 'info@simiwine.com',
        address: 'თბილისი, საქართველო',
        rights: 'ყველა უფლება დაცულია.',
        createdBy: 'Created by'
    },
    EN: {
        slogan: 'From vine to winery – a living heritage and exceptional Georgian wine.',
        navTitle: 'Navigation',
        contactTitle: 'Contact',
        socialTitle: 'Social Media',
        home: 'Home',
        about: 'About Us',
        products: 'Products',
        contact: 'Contact',
        phone: '+995 592 292 828',
        email: 'info@simiwine.com',
        address: 'Tbilisi, Georgia',
        rights: 'All rights reserved.',
        createdBy: 'Created by'
    },
    RU: {
        slogan: 'От лозы к виноделию – живое наследие и исключительное грузинское вино.',
        navTitle: 'Навигация',
        contactTitle: 'Контакты',
        socialTitle: 'Социальные сети',
        home: 'Главная',
        about: 'О нас',
        products: 'Продукты',
        contact: 'Контакты',
        phone: '+995 592 292 828',
        email: 'info@simiwine.com',
        address: 'Тбилиси, Грузия',
        rights: 'Все права защищены.',
        createdBy: 'Created by'
    }
};